import { render, staticRenderFns } from "./onlineSupport.vue?vue&type=template&id=47237347&scoped=true&"
import script from "./onlineSupport.vue?vue&type=script&lang=js&"
export * from "./onlineSupport.vue?vue&type=script&lang=js&"
import style0 from "./onlineSupport.vue?vue&type=style&index=0&id=47237347&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47237347",
  null
  
)

export default component.exports